import { FC } from 'react';

import { Button, CtaLink } from '@purpur/library';
import { IconArrowRight } from '@purpur/library/icon/arrow-right';

import { ORDER_CART_TEST_ID } from '../constants';
import { CartActionData, isTypeFormSubmitHandler, isTypeLinkHandler } from '../model';

export const CartAction: FC<{ data: CartActionData }> = ({ data }) => {
    if (isTypeLinkHandler(data)) {
        return (
            <CtaLink
                variant={data.variant || 'primary'}
                onClick={data.onClick}
                href={data.url}
                showIcon={data.hasArrow}
                fullWidth={true}
                data-test={ORDER_CART_TEST_ID.ACTION}
            >
                {data.text}
            </CtaLink>
        );
    }

    return (
        <Button
            type={isTypeFormSubmitHandler(data) ? 'submit' : 'button'}
            variant={data.variant || 'primary'}
            onClick={data.onClick}
            fullWidth={true}
            data-test={ORDER_CART_TEST_ID.ACTION}
            disabled={data.isDisabled}
            loading={data.isLoading}
        >
            {data.text}
            {data.hasArrow && <IconArrowRight size="xs" />}
        </Button>
    );
};
